import { TextButton } from '@cinch-labs/design-system'
import { penceToPounds } from '@cinch-labs/shared-util'
import { useAdminFeeDrawer } from '../admin-fee-drawer/admin-fee-drawer.context'
import styles from './admin-fee-text.module.css'
import { useAdminFeeTextTracking } from './admin-fee-text.tracking'

interface AdminFeeTextProps {
  adminFee: number
  trackingValue: string
}

export const AdminFeeText = ({
  adminFee,
  trackingValue,
}: AdminFeeTextProps) => {
  const { showAdminFeeDrawer, setShowAdminFeeDrawer } = useAdminFeeDrawer()
  const trackingEvents = useAdminFeeTextTracking()

  const handleClick = () => {
    trackingEvents.onAdminFeeClick(trackingValue)
    setShowAdminFeeDrawer(!showAdminFeeDrawer)
  }

  return (
    <TextButton
      classNames={{
        button: styles.adminFee,
      }}
      onClick={() => handleClick()}
      aria-controls="admin-fee-drawer"
    >
      {`Plus a ${penceToPounds(adminFee)} admin fee`}
    </TextButton>
  )
}
